import { useEffect } from "react";
import { AboutusSection } from "@/components/landing/Aboutus";

const AboutUs = () => {
  useEffect(() => {
    const prevTitle = document.title;
    document.title = "About Us - Duri Ridesharing";
    return () => {
      document.title = prevTitle;
    };
  }, []);

  return (
    <div className="min-h-screen bg-background-cream font-roboto">
      <main>
        <AboutusSection />
      </main>
    </div>
  );
};

export default AboutUs;
